// ========================================
// ⚙️ CONFIGURAÇÃO - FRONTEND
// ========================================

export const CONFIG = {
    numeroConvenio: 3648981,
    agencia: '4148',
    conta: '25651'
};
